module.exports = __webpack_public_path__ + "img/info-result.43cb6e45.svg";